import m from "mithril";
import Requester from "../../../shared/request";
import Gateway from "../../../shared/app_settings";
import i18n from "../../../shared/i18n/i18n";
import Toasts from "../../../shared/toasts";
import ModalManager from "../../../shared/modal";
import FormUtilities from "../../../shared/utilities/form_utilities";
import UniqueName from "../../../shared/uniqueName";
import RouterService from "../../../shared/services/router.service";
import TextEditor from "../../../shared/components/component_text_editor";
import TextUtilities from "../../../shared/utilities/text_utilities";

let modalId;
let saving = false;
let uploading = false;

let unit = {
    name: "",
    description: "",
    instructions: ""
};

function resetUnit() {
    unit = {
        name: "",
        description: "",
        instructions: ""
    };
}

function saveUnit() {
    if (!FormUtilities.validateFields(".modal input") || !TextUtilities.hasVisibleText(unit.instructions)) return;

    saving = true;
    Requester.post(Gateway.admin + "units/assessment", unit)
        .then(result => {
            ModalManager.close(modalId);
            RouterService.navigateToUnit(result);
        })
        .catch(error => {
            const errCode = error?.response?.properties?.errorCode || "unknown_error";
            Toasts.add("error", i18n.t("error"), i18n.t(errCode));
        })
        .finally(() => {
            saving = false;
        });
}

function isSaveEnabled() {
    return (
        !saving &&
        !uploading &&
        UniqueName.isUnitNameUnique &&
        !UniqueName.unitLoading &&
        TextUtilities.hasVisibleText(unit.instructions)
    );
}

const Modal_Unit_Assessment_New = {
    oninit: () => {
        resetUnit();
    },

    view: () => {
        return [
            // Name
            m(".form-section.required", [
                m(".form-label", i18n.t("name")),
                m("input[type=text]", {
                    value: unit.name,
                    oninput: e => unit.name = e.target.value,
                    onchange: e => UniqueName.checkUniqueUnitName("new", e.target.value.trim())
                })
            ]),

            // Description
            m(".form-section", [
                m(".form-label", i18n.t("description_assessment")),
                m("textarea", {
                    value: unit.description,
                    oninput: e => unit.description = e.target.value
                })
            ]),

            // Instructions
            m(".form-section.required", [
                m(".form-label", i18n.t("instructions_will_appear_for_learners")),
                m(TextEditor, {
                    content: encodeURIComponent(unit.instructions || ""),
                    hideHyperlink: true,
                    onchange: function (content) {
                        unit.instructions = content;
                    }
                }),
                !TextUtilities.hasVisibleText(unit.instructions) ? m(".text-error.padding", {style: "font-size: 0.75rem;"}, i18n.t("complete_required_fields")) : ""
            ]),

            // Save Button
            m(".form-buttons", [
                saving || uploading
                    ? m("button.btn-text no-click", [i18n.t("saving"), m(".loading-dots")])
                    : m("button", {
                        class: isSaveEnabled() ? "" : "btn-text no-click",
                        onclick: isSaveEnabled() ? saveUnit : null
                    }, i18n.t("save"))
            ])
        ];
    },

    setModalId: id => {
        modalId = id;
    }
};

export default Modal_Unit_Assessment_New;
